module.exports = __webpack_public_path__ + "static/img/monitoring.8fc461b0.svg";